'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FeatherAlertTriangle } from '@subframe/core';
import { Button, Dialog, TextArea } from '@/shared/components/ui';
interface RecusarEnvioArDialogProps {
  aberto: boolean;
  requeridoNome: string;
  onFechar: () => void;
  onRecusar: (motivo: string) => void;
}
export function RecusarEnvioArDialog(t0) {
  const $ = _c(29);
  const {
    aberto,
    requeridoNome,
    onFechar,
    onRecusar
  } = t0;
  const [motivo, setMotivo] = useState("");
  let t1;
  if ($[0] !== onFechar) {
    t1 = () => {
      setMotivo("");
      onFechar();
    };
    $[0] = onFechar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleFechar = t1;
  let t2;
  if ($[2] !== motivo || $[3] !== onRecusar) {
    t2 = () => {
      onRecusar(motivo);
      setMotivo("");
    };
    $[2] = motivo;
    $[3] = onRecusar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleRecusar = t2;
  let t3;
  if ($[5] !== handleFechar) {
    t3 = open => !open && handleFechar();
    $[5] = handleFechar;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-heading-3 font-heading-3 text-default-font">Não enviar a carta agora</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `A citação de ${requeridoNome} continua pendente. A secretaria será avisada e vai avaliar o próximo passo do processo.`;
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t4}<span className="text-caption font-caption text-subtext-color">{t5}</span></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = evento => setMotivo(evento.target.value);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== motivo) {
    t8 = <TextArea label={"Por que n\xE3o quer enviar? (opcional)"} className="w-full"><TextArea.Input value={motivo} onChange={t7} placeholder="Ex.: prefiro tentar de novo pelo WhatsApp antes de mandar a carta." rows={3} /></TextArea>;
    $[11] = motivo;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-error-50 border-error-200 flex items-start gap-2 rounded-[8px] border border-solid px-3 py-2"><FeatherAlertTriangle className="text-error-600 mt-0.5 h-3.5 w-3.5 shrink-0" /><span className="text-caption font-caption text-error-700">Sem a citação, o processo não avança. Você pode voltar atrás enquanto a secretaria não agir.</span></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== handleFechar) {
    t10 = <Button variant="neutral-secondary" onClick={handleFechar}>Voltar</Button>;
    $[14] = handleFechar;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== handleRecusar) {
    t11 = <Button variant="destructive-primary" onClick={handleRecusar}>Confirmar recusa</Button>;
    $[16] = handleRecusar;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <div className="flex w-full items-center justify-end gap-3">{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6 || $[23] !== t8) {
    t13 = <Dialog.Content className="w-full max-w-[520px] gap-5 rounded-[16px] p-6">{t6}{t8}{t9}{t12}</Dialog.Content>;
    $[21] = t12;
    $[22] = t6;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== aberto || $[26] !== t13 || $[27] !== t3) {
    t14 = <Dialog open={aberto} onOpenChange={t3}>{t13}</Dialog>;
    $[25] = aberto;
    $[26] = t13;
    $[27] = t3;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}